<div class="product-grid">
  <div *ngFor="let catalogItem of data | async" class="product-grid__item">
    <app-catalog-product-description
      [catalogItem]="catalogItem"
      (click)="descriptionClicked.emit(catalogItem)"
      [disabled]="!catalogItem.isUserAllowedToOrderItem"
    ></app-catalog-product-description>
    <button
      mat-flat-button
      color="primary"
      class="item__cart-button"
      (click)="addToCartClicked.emit(catalogItem)"
      [disabled]="!catalogItem.isUserAllowedToOrderItem"
    >
      <mat-icon class="item__cart-button-icon">add_shopping_cart</mat-icon>
    </button>
  </div>
</div>
